import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PointSummaryDTO } from 'src/app/shared/models/dtos/responses/point-summary/point-summary-dto';
import { BusinessResponseDTO } from 'src/app/shared/models/dtos/register-form/business-response-dto/business-response-dto';
import { Representative } from 'src/app/shared/models/dtos/register-form/representative/representative';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { ProfileMenuItems } from 'src/app/shared/models/profile-menu-items/profile-menu-items';
import { BusinessSummaryDTO } from 'src/app/shared/models/dtos/responses/business-summary/business-summary-dto';

@Component({
  selector: 'app-top-header-desktop',
  templateUrl: './top-header-desktop.component.html',
  styleUrls: ['./top-header-desktop.component.scss'],
})
/**
 * Top header
 */
export class TopHeaderDesktopComponent implements OnInit, OnChanges {
  @Input() representative?: Representative;
  @Input() pointSummary?: PointSummaryDTO;
  @Input() business?: BusinessResponseDTO;
  @Input() businessSummary?: BusinessSummaryDTO;
  @Input() loading = false;
  language = '';

  profileMenuItems = new ProfileMenuItems();
  labels = {
    totalPoints: 'total-points',
    pointsAddedMonth: 'points-added-month',
    pointsExpiringMonth: 'points-expiring-month',
    pointsRedeemedMonth: 'points-redeemed-month',
    equipments: 'equipments',
    series: 'series',
    pointsExpiring: 'points-expiring-december',
    uploadedImgAlt: 'uploaded-image-alt',
    businessLevelDescription: 'entry-level',
    showMore: 'show-more',
    totalPointsFor: 'total-points-for',
  };
  isVip: boolean = false;
  vipLevelDescription: string = '';

  /**
   * @constructor
   */
  constructor(
    private translationService: TranslationService,
    private router: Router
  ) {}

  /**
   * onChanges
   */
  ngOnChanges(): void {
    if (this.business?.businessLevels![0]) {
      if (this.business!.businessLevels![0].description !== 'Entry level') {
        this.isVip = true;
        this.vipLevelDescription = this.business.businessLevels[0].description;
      }
    }
  }

  /**
   * Init
   */
  ngOnInit() {
    this.translationService.translateObject(this.labels);
    this.translationService.translateObject(this.profileMenuItems);
    this.language = this.translationService.getActiveLang();
  }

  /**
   * Redirect to the point balance
   */
  navigateToPointsDetail() {
    this.router.navigate(['/point-balance-list']);
  }
}
